export default __webpack_public_path__ + "static/media/banner1-mobile.4860c8ef.png";